const defaults = {
  apiUrl: 'https://9gwidkp5i5.execute-api.us-east-1.amazonaws.com',
  redirectUrl: 'https://dev.highlights.digital',
  videoUrl: 'https://video-dev.highlights.digital',
  publicLinkUrl: 'https://links.highlights.digital',
  awsRegion: 'us-east-1',
  cognitoUserPoolId: 'us-east-1_uynEHxkJW',
  cognitoWebClientId: '1707c3sjom93l2nbrovlaqokl'
}

const injected = globalThis.__HIGHLIGHTS_CONFIG__ || {}

const env = {
  ...defaults,
  ...injected
}

export default env
